import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { createSetting } from '../../../actions/settings';
import { newToast } from '../../../actions/shared';
const SettingsForm = () => {

  const dispatch = useDispatch();

  const [formData, setFormData] = useState({
    key: '',
    value: '',
  });

  const handleSubmit = (event) => {
    event.preventDefault();
    dispatch(createSetting(formData));
    setFormData({
      key: "",
      value: "",
    })
    newToast("Setting created.")
  }

  return (
    <div className='new-question-form'>
      <h2>Create new Setting</h2>
      <div>
        <form onSubmit={handleSubmit} className='form-group'>
          <label htmlFor='key'>Key</label>
          <input name="key" onChange={(e) => setFormData({ ...formData, key: e.target.value })} value={formData.key} className="form-control center" id="key" aria-describedby="key" type="text" />
          <label htmlFor='value'>Value</label>
          <input name="value" onChange={(e) => setFormData({ ...formData, value: e.target.value })} value={formData.value} className="form-control center" id="value" aria-describedby="value" type="text" />
          <button type="submit" className="btn btn-primary">Create Setting</button>
        </form>
      </div>
    </div>
  )
}

export default SettingsForm;